import { useQuery } from "react-query"
import { AxiosResponse } from "axios"

import { GetKeywordsRes } from "types/content"
import languagesService from "api/contentService"

import { LANGS } from "types/shared"

const useGetKeywords = (lang: LANGS, enabled = true) => {
  return useQuery("keywords", async () => {
    try {
      const res: AxiosResponse<GetKeywordsRes> = await languagesService.getKeywords(lang)

      return res.data
    } catch (err: any) {
      return err.response
    }
  }, { enabled })
}

export default useGetKeywords